/*
 * Authors: mariushirjanu
 * Created: 29/06/2023
 */
import { Component, Input, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'underscore';
import * as Noty from 'noty';
import {
  STATE_ORDERENTRY_CART, STATE_ORDERENTRY,
  STATE_ORDERENTRY_CATALOG_DETAIL,
  STATE_ORDERENTRY_CATALOG_GUIDE,
  STATE_ORDERENTRY_CATALOG_OVERVIEW,
  STATE_ORDERENTRY_CHARGES,
  STATE_ORDERENTRY_CONFIRM,
  STATE_ORDERENTRY_DOCUMENTS,
  STATE_ORDERENTRY_INVOICE,
  STATE_ORDERENTRY_ORDER_INFO,
  STATE_ORDERENTRY_OVERVIEW,
  STATE_ORDERENTRY_PAYMENT,
  STATE_ORDERENTRY_SHIPPING,
  STATE_ORDERENTRY_WEBSHOP
} from '../../../shared/app-states';
import {
  EVENT_ORDER_BP_SELECTION_UPDATED,
  EVENT_ORDER_BUSY_STATUS_CHANGED, EVENT_ORDER_CONTEXT_UPDATED, EVENT_ORDER_COUNTRY_SELECTION_UPDATED,
  EVENT_ORDER_LOADING_BPS,
  EVENT_ORDER_LOADING_COUNTRIES, EVENT_ORDER_REQUESTER_CONTACT_CHANGED,
  EVENT_ORDER_LOADING_CONTEXT, EVENT_ORDER_WEBSHOP_SELECTION_UPDATED
} from '../../../shared/app-events';
import { StateDeclaration, StateService, Transition, TransitionService } from '@uirouter/angular';
import { OrderEntryRequesterService } from './requester/order-entry-requester.service';
import { AuthService } from '../../../shared/services/auth/auth.service';
import { BodyClassService } from '../../../shared/services/body-class.service';
import { ICurrency, IObject } from '../../../../type_definitions/datatypes';
import { BillingType, IOrderContext, IOrderPermissions, IOrderResponse, IPONumberCheck, ITaxInfo, OrderEntryDataService } from './order-entry-data.service';
import { POType } from '../../payment/payment-data.service';
import { ACTION_CODE_CANCEL, ACTION_CODE_GOTOSUBMIT, ACTION_CODE_SAVEFORLATER, ACTION_CODE_SUBMIT } from './order-entry.constants';
import { FormattingService } from '../../../shared/services/formatting.service';
import { OrderCatalogDataService } from '../catalog/order-catalog-data.service';
import { OrderEntryChargesService } from './charges/order-entry-charges.service';
import { OrderEntryPaymentService } from './payment/order-entry-payment.service';
import { OrderCatalogService } from '../catalog/order-catalog.service';
import { BuyingGuideModel } from '../catalog/guide/buying-guide.model';
import { DEFAULT_STOCK_ORDER_TYPE, OrderEntryInfoService } from './order-info/order-entry-info.service';
import { OrderEntryWebshopService } from './webshop/order-entry-webshop.service';
import { OrderWebshopLoaderService } from './webshop/order-webshop-loader.service';
import { WIZARD_ORDER } from '../../../shared/app-wizards';
import { CatalogStateService } from '../catalog/catalog-state.service';
import { PriceCartService } from '../cart/price-cart.service';
import { PartConfiguratorDataService } from '../cart/part-configurator-data.service';
import { OrderEntryShippingService } from './location/shipping/order-entry-shipping.service';
import { OrderEntryInvoiceService } from './location/invoice/order-entry-invoice.service';
import { GaEventService, IGAEvent } from '../../../shared/services/ga-event.service';
import { OrderEntryService } from './order-entry.service';
import { GaWizardService } from '../../../shared/wizard/ga-wizard.service';
import { GaWizard, IWizardStep } from '../../../shared/wizard/ga-wizard';
import { DialogSize, GaMessageService, IDialog, MessageType } from '../../../shared/message/ga-message.service';
import { OrderEntryChargesDataService } from './charges/order-entry-charges-data.service';
import { TranslationService } from '../../../shared/translation/translation.service';
import { IValidationResults } from '../../../shared/formly/ga-validate.service';
import { CatalogGuideComponent } from '../catalog/guide/catalog-guide.component';
import { OrderCatalogOverviewComponent } from '../catalog/overview/order-catalog-overview.component';
import { GaDeferredService, IGADeferred } from '../../../shared/services/ga-deferred.service';
import { OrderEntryWebshopComponent } from './webshop/order-entry-webshop.component';
import { CartComponent } from '../cart/cart.component';
import { OrderEntryInfoComponent } from './order-info/order-entry-info.component';
import { OrderEntryPaymentComponent } from './payment/order-entry-payment.component';
import { OrderEntryShippingComponent } from './location/shipping/order-entry-shipping.component';
import { OrderEntryInvoiceComponent } from './location/invoice/order-entry-invoice.component';
import { OrderEntryDocumentsComponent } from './documents/order-entry-documents.component';
import { OrderEntryChargesComponent } from './charges/order-entry-charges.component';
import { OrderEntryConfirmComponent } from './confirm/order-entry-confirm.component';

import { Subscription } from 'rxjs';
import { IAddressData } from './location/base-order-entry-location-to.service';
import { OrderEntryCancelDialogComponent } from './order-entry-cancel-dialog.component';
import { PAYMENTTYPE_PO } from '../../../shared/services/billing/billing-data.service';
import { util } from '../../../shared/util';
import { DefaultDialogComponent } from '../../../shared/message/dialogs/default-dialog.component';
import { OrderEntryStepId } from './order-entry-steps';
import { StateOrName } from '@uirouter/core/lib/state/interface';
import { RawParams } from '@uirouter/core/lib/params/interface';
import { TransitionOptions } from '@uirouter/core/lib/transition/interface';
import { UiOnParamsChanged } from '@uirouter/angular';

interface IOrder {
  order:IOrderResponse;
  single:boolean;
}

@Component({
  selector: 'order-entry',
  template: `
    <div class="order-entry">
      <div *ngIf="error" class="alert alert-danger"><strong>{{error}}</strong></div>
    
      <div *ngIf="!error">
        <h2 *ngIf="initialLoad">
          <activity-indicator></activity-indicator>
          <span translate>{{loadMessage}}</span>
        </h2>
        <div *ngIf="!initialLoad">
          <fixed-to-top>
            <div class="navbar-wizard clearfix">
              <div class="clearfix">
                <wizard-controls *ngIf="orderPermissions?.editable && orderEditable" [wizardId]="wizardId"></wizard-controls>
    
                <div *ngIf="orderPermissions?.editable && orderEditable" class="float-end">
                  <div class="checkout-dropdown row">
                    <mail-notifications [value]="sendMail" (onChange)="onEmailNotificationChange($event)" *ngIf="acslUser" class="col-auto pe-0"></mail-notifications>
                    
                    <div class="col-auto btn-group d-none d-sm-block d-sm-none d-md-block">
                      <button *ngIf="orderPermissions.allowSubmit || orderPermissions.allowToApprove" class="btn btn-primary" [busyButton]="buttonBusy.checkout" [disabled]="executing" (click)="checkout()">
                        <span *ngIf="orderPermissions.allowSubmit" translate>ORDERENTRY.BUTTONS.SUBMIT</span>
                        <span *ngIf="orderPermissions.allowToApprove" translate>ORDERENTRY.BUTTONS.APPROVAL</span>
                      </button>
                      <button *ngIf="orderPermissions.allowApprovalReminder" class="btn btn-primary" [disabled]="executing || sendReminderDisabled" (click)="sendReminder()">
                        <span translate>ORDERENTRY.BUTTONS.REMINDER</span>
                      </button>
                      <button *ngIf="orderPermissions.allowSaveForLater" class="btn btn-primary" [busyButton]="buttonBusy.saveForLater" [disabled]="executing" (click)="saveForLater()">
                        <span translate>GA.BUTTONS.SAVE_FOR_LATER</span>
                      </button>
                      <button *ngIf="orderPermissions.allowCancelOrder && orderId" class="btn btn-primary" [busyButton]="buttonBusy.cancel" [disabled]="executing" (click)="cancelOrderDialog()">
                        <span translate>ORDERENTRY.BUTTONS.CANCEL</span>
                      </button>
                      <a *ngIf="referrer" class="btn btn-primary" [href]="referrer">
                        <span translate>GA.BUTTONS.EXIT</span>
                      </a>
                    </div>
    
                    <div class="col-auto btn-group d-md-none d-lg-none" dropdown>
                      <button type="button" class="btn btn-primary dropdown-toggle" dropdownToggle [busyButton]="executing">
                        <span class="dropdown-title" translate>ORDERENTRY.ORDER_ACTIONS</span>
                      </button>
                      <ul *dropdownMenu class="dropdown-menu" role="menu">
                        <li *ngIf="orderPermissions.allowSubmit">
                          <a href="javascript:void(0)" (click)="checkout()" translate>ORDERENTRY.BUTTONS.SUBMIT</a>
                        </li>
                        <li *ngIf="orderPermissions.allowToApprove">
                          <a href="javascript:void(0)" (click)="checkout()" translate>ORDERENTRY.BUTTONS.APPROVAL</a>
                        </li>
                        <li *ngIf="orderPermissions.allowApprovalReminder && !sendReminderDisabled">
                          <a href="javascript:void(0)" (click)="sendReminder()" translate>ORDERENTRY.BUTTONS.REMINDER</a>
                        </li>
                        <li *ngIf="orderPermissions.allowSaveForLater">
                          <a href="javascript:void(0)" (click)="saveForLater()" translate>GA.BUTTONS.SAVE_FOR_LATER</a>
                        </li>
                        <li *ngIf="orderPermissions.allowCancelOrder && orderId">
                          <a href="javascript:void(0)" (click)="cancelOrderDialog()" translate>ORDERENTRY.BUTTONS.CANCEL</a>
                        </li>
                        <li *ngIf="referrer">
                          <a [href]="referrer" translate>GA.BUTTONS.EXIT</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <cart-popup [orderId]="orderId"></cart-popup>
                </div>
                <div *ngIf="!orderEditable" class="float-end">
                  <button class="btn btn-primary" *ngIf="orderPermissions?.editable" (click)="edit()" translate>GA.BUTTONS.EDIT</button>
                  <button class="btn btn-primary" *ngIf="orderPermissions?.allowApprovalReminder" [disabled]="sendReminderDisabled || executing" (click)="sendReminder()" translate>ORDERENTRY.BUTTONS.REMINDER</button>
                  <button class="btn btn-primary" *ngIf="orderPermissions?.allowCancelOrder" [busyButton]="buttonBusy.cancel" [disabled]="executing" (click)="cancelOrderDialog()" translate>ORDERENTRY.BUTTONS.CANCEL</button>
                </div>
                <h1 class="webshop-title">
                  {{ title }}
                  <span *ngIf="orderNumber"> /
                    <span class="order-number" translate [translateParams]="{number: orderNumber}">ORDERENTRY.ORDER</span>
                  </span>
                  <span *ngIf="orderStatus"> /
                    <span class="order-status">{{ orderStatus }}</span>
                  </span>
                  <span class="navbar-title-right">
                    <span *ngIf="stockOrderType && stockOrderType != defaultStockOrderType" translate>
                      {{ 'ORDERENTRY.STOCK_ORDER_TYPES.' + stockOrderType }}
                    </span>
                    <span *ngIf="testMode"> /
                      <span translate>ORDERENTRY.TEST_ORDER</span>
                    </span>
                  </span>
                </h1>
              </div>
            </div>
            <h3 class="webshop-title d-none d-print-block">
              {{ title }}
              <span *ngIf="orderNumber"> /
                <span class="order-number" translate [translateParams]="{number: orderNumber}">ORDERENTRY.ORDER</span>
              </span>
              <span *ngIf="orderStatus"> /
                <span class="order-status">{{ orderStatus }}</span>
              </span>
              <span class="navbar-title-right">
                <span *ngIf="stockOrderType && stockOrderType != defaultStockOrderType" translate>
                  ORDERENTRY.MASTER_STOCK_ORDER
                </span>
                <span *ngIf="testMode"> /
                  <span translate>ORDERENTRY.TEST_ORDER</span>
                </span>
              </span>
            </h3>
          </fixed-to-top>
          <div class="order-content">
            <ui-view></ui-view>
          </div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./order-entry.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderEntryComponent implements OnInit, OnDestroy, UiOnParamsChanged {
  @Input() public orderId:number;
  @Input() public new:boolean;
  @Input() public referrer:string;
  @Input('stockOrderType') public stockOrderTypeParam:string;
  @Input() public debug:boolean;

  public initialLoad:boolean;
  public buttonBusy:{ [ key:string ]:boolean };
  public executing:boolean;
  public sendReminderDisabled:boolean;
  private loadedOrder:IOrder;
  private _orderPermissions:IOrderPermissions;
  public loadMessage:string;
  public acslUser:boolean;
  public error:string;
  public customerCurrencies:ICurrency[];
  public orderCurrency:ICurrency;
  public defaultStockOrderType:string = DEFAULT_STOCK_ORDER_TYPE;
  public sendMail:boolean = true;
  private wizard:GaWizard;
  public wizardId:string = WIZARD_ORDER;
  private eventHandler:Subscription;
  private stepsEventHandler:Subscription;
  private onStateBeforeHook:Function;
  private onStateSuccessHook:Function;
  private firstBillingTypeAndShipToAddress:boolean;
  private backupRequesterContactId:number;
  private backupOrderContext:IOrderContext;
  private hasPendingStateChange:boolean;

  constructor(
    private authService:AuthService,
    private bodyClassService:BodyClassService,
    private deferredService:GaDeferredService,
    private formattingService:FormattingService,
    private messageService:GaMessageService,
    private wizardService:GaWizardService,
    private orderEntryDataService:OrderEntryDataService,
    private orderEntryService:OrderEntryService,
    private orderCatalogService:OrderCatalogService,
    private orderCatalogDataService:OrderCatalogDataService,
    private catalogStateService:CatalogStateService,
    private orderEntryChargesDataService:OrderEntryChargesDataService,
    private orderEntryChargesService:OrderEntryChargesService,
    private orderEntryInfoService:OrderEntryInfoService,
    private orderEntryPaymentService:OrderEntryPaymentService,
    private priceCartService:PriceCartService,
    private partConfiguratorDataService:PartConfiguratorDataService,
    private orderWebshopLoaderService:OrderWebshopLoaderService,
    private orderEntryWebshopService:OrderEntryWebshopService,
    private buyingGuideModel:BuyingGuideModel,
    private orderEntryRequesterService:OrderEntryRequesterService,
    private orderEntryShippingService:OrderEntryShippingService,
    private orderEntryInvoiceService:OrderEntryInvoiceService,
    private translationService:TranslationService,
    private eventService:GaEventService,
    private stateService:StateService,
    private transitionService:TransitionService
  ) {
    this.wizard = this.wizardService.getInstance(WIZARD_ORDER);
  }

  public ngOnInit():void {
    this.start(this.orderId);

    this.orderEntryService.checkout = this.checkout;
  }

  private start(order:number):void {
    if (this.new) {
      //restart to get rid of the current order details
      this.stateService.go(STATE_ORDERENTRY_WEBSHOP, { new: undefined });
      return;
    }

    this.initialLoad = true;
    this.buttonBusy = {};
    this.executing = false;
    this.orderId = order;
    this.loadMessage = this.orderId? 'ORDERENTRY.LOADING' : 'ORDERENTRY.WEBSHOP.LOADING_SHOPS';
    this.orderPermissions = <IOrderPermissions>{
      editable: true,
      allowSaveForLater: true
    };
    this.acslUser = this.authService.checkAcslUser();
    this.firstBillingTypeAndShipToAddress = true;

    this.activate();
    this.listen();
  }

  private listen():void {
    this.eventHandler = this.eventService.events
      .subscribe((event:IGAEvent) => {
      if(event.name === EVENT_ORDER_CONTEXT_UPDATED){
        this.onOrderContextChanged(event.data);
      }

      if(event.name === EVENT_ORDER_REQUESTER_CONTACT_CHANGED){
        const requesterContactId:number = event.data?.id;
        if (this.backupRequesterContactId && (requesterContactId !== this.backupRequesterContactId)) {
          this.orderEntryService.clearOrderDataWhenRequesterChanges();
        }
        this.backupRequesterContactId = requesterContactId;
      }
    });

    this.stepsEventHandler = this.eventService.events.subscribe((event:IGAEvent) => {
      if([
        EVENT_ORDER_WEBSHOP_SELECTION_UPDATED,
        EVENT_ORDER_LOADING_COUNTRIES,
        EVENT_ORDER_COUNTRY_SELECTION_UPDATED,
        EVENT_ORDER_LOADING_BPS,
        EVENT_ORDER_BP_SELECTION_UPDATED,
        EVENT_ORDER_LOADING_CONTEXT,
        EVENT_ORDER_CONTEXT_UPDATED,
        EVENT_ORDER_REQUESTER_CONTACT_CHANGED
      ].indexOf(event.name) >= 0){
        this.enableDisableSteps();
      }

      if([
        EVENT_ORDER_COUNTRY_SELECTION_UPDATED,
        EVENT_ORDER_BP_SELECTION_UPDATED
      ].indexOf(event.name) >= 0){
        this.tryToOverwriteVAT();
      }
    });

    this.onStateBeforeHook = this.transitionService.onBefore({}, (transition:Transition) => {
      const toState:StateDeclaration = transition.to();
      const fromParams:IObject = transition.params('from');
      const toParams:IObject = transition.params('to');

      // prevent state change to other orderentry states when order is not editable
      if (!this.orderPermissions.editable && toState.name.indexOf(STATE_ORDERENTRY) === 0 && fromParams.order === toParams.order && toState.name !== STATE_ORDERENTRY_OVERVIEW) {
        transition.abort();
      }
    });

    this.onStateSuccessHook = this.transitionService.onSuccess({}, this.onStateSuccess);
  }

  private onStateSuccess = (transition:Transition) => {
    const fromState:StateDeclaration = transition.from();
    const toState:StateDeclaration = transition.to();

    if (fromState && fromState.name === STATE_ORDERENTRY_CATALOG_OVERVIEW && toState && toState.name === STATE_ORDERENTRY_CATALOG_OVERVIEW) {
      this.wizard.step(OrderEntryStepId.CATALOG).stateParams = transition.params();
    }
    // set read/edit mode when using browser forward and back
    if (toState?.name === STATE_ORDERENTRY_OVERVIEW) {
      this.orderEntryService.orderEditable = false;
    } else if (toState.name !== STATE_ORDERENTRY_WEBSHOP) {
      this.orderEntryService.orderEditable = true;
    }
  };

  private tryToOverwriteVAT():void {
    const billingTypeId:BillingType = this.orderEntryInvoiceService.billingType?.id;
    const bpId:number = this.orderEntryWebshopService.selectedBP? this.orderEntryWebshopService.selectedBP.id : undefined;

    const shippingAddress:IAddressData = this.orderEntryShippingService.addressData;
    const shipToStateCode:string = shippingAddress?.state?.id;
    const shipToCountryId:number = shippingAddress?.country?.id || this.orderEntryWebshopService.selectedCountry?.id;

    const invoiceAddress:IAddressData = this.orderEntryInvoiceService.addressData;
    const invoiceToCountryId:number = invoiceAddress?.country?.id || this.orderEntryWebshopService.selectedCountry?.id;

    if (billingTypeId && shipToCountryId && bpId) {
      if (!this.firstBillingTypeAndShipToAddress) {
        this.overrideVAT(shipToCountryId, shipToStateCode, invoiceToCountryId);
      } else {
        this.firstBillingTypeAndShipToAddress = false;
      }
    }
  }

  private onOrderContextChanged(orderContext:IOrderContext):void {
    if(orderContext) {
      const currencies:ICurrency[] = orderContext.customerCurrencies;
      const defaultOrderCurrency:ICurrency = orderContext.defaultOrderCurrency;

      if (currencies && defaultOrderCurrency) {
        this.customerCurrencies = currencies;
        this.orderCurrency = _.findWhere(this.customerCurrencies, { isoCode: defaultOrderCurrency.isoCode });
        this.priceCartService.currency = defaultOrderCurrency.isoCode;
        this.orderCatalogService.currency = defaultOrderCurrency.isoCode;
      }

      if (this.orderCurrency) {
        this.priceCartService.currency = this.orderCurrency.isoCode;
        this.orderCatalogService.currency = this.orderCurrency.isoCode;
      }

      if (orderContext.tagField) {
        this.orderEntryInfoService.tagField = orderContext.tagField;
      }

      if (orderContext.tagField2) {
        this.orderEntryInfoService.tagField2 = orderContext.tagField2;
      }

      if (orderContext.billingType) {
        this.orderEntryInvoiceService.billingType = { id: orderContext.billingType };
        this.tryToOverwriteVAT();
      }

      if (orderContext.paymentType) {
        this.orderEntryPaymentService.paymentTypeId = orderContext.paymentType;
      }

      if (!this.orderId && orderContext.orderPermissions) {
        this.orderPermissions = orderContext.orderPermissions;
      }

      if (this.backupOrderContext && !_.isEqual(orderContext, this.backupOrderContext) && !this.orderId) {
        this.orderEntryService.clearAllOrderData();
      }

      this.backupOrderContext = _.clone(orderContext);
    }
  }

  private activate = ():void => {
    this.orderCatalogDataService.start();
    this.catalogStateService.overviewState = STATE_ORDERENTRY_CATALOG_OVERVIEW;
    this.catalogStateService.detailState = STATE_ORDERENTRY_CATALOG_DETAIL;
    this.bodyClassService.add('wizard-header');
    this.initWizard();
    this.onEmailNotificationChange(this.sendMail);

    const errormessage:string = 'You cannot access this order. It does not exist or you do not have permissions to access it.';
    this.loadOrder()
      .then((order:IOrderResponse) => {
        if (this.orderId && !order) {
          this.error = errormessage;
          return Promise.reject();
        }
        return this.orderWebshopLoaderService.start('PO', undefined, order, this.stockOrderTypeParam);
      })
      .then(this.loadingDone)
      .catch(() => {
        this.error = errormessage;
      });

    this.onOrderContextChanged(this.orderEntryWebshopService.shopContext);
  };

  private enableDisableSteps = ():void => {
    if(!this.hasPendingStateChange) {
      if (!this.orderEntryWebshopService.selectedShop || this.orderEntryWebshopService.loadingCountries || !this.orderEntryWebshopService.selectedCountry || this.orderEntryWebshopService.loadingBPs || !this.orderEntryWebshopService.selectedBP) {
        this.wizard.someEnabled(0, 'ORDERENTRY.WEBSHOP.PLEASE_SELECT_WEBSHOP_COUNTRY'); //will disable every but the first step
      } else if (this.orderEntryWebshopService.loadingContext) {
        this.wizard.someEnabled(0, 'ORDERENTRY.WEBSHOP.STILL_LOADING_WEBSHOP'); //will disable every but the first step
      } else if (this.orderEntryService.requesterRequired && !this.orderEntryRequesterService.contact) {
        this.wizard.someEnabled(0, 'ORDERENTRY.WEBSHOP.PLEASE_SELECT_REQUESTER'); //will disable all but the first step
      } else {
        this.wizard.allEnabled();
      }

      const catalogStep:IWizardStep = this.wizard.step(OrderEntryStepId.CATALOG);
      if (this.catalogStateService.buyingGuideId) {
        this.wizard.step(OrderEntryStepId.CATALOG, this.wizardService.createStep(OrderEntryStepId.CATALOG, 'CATALOG.BUYERSGUIDE.TITLE', CatalogGuideComponent, STATE_ORDERENTRY_CATALOG_GUIDE, catalogStep.stateParams, catalogStep.stateChildren, catalogStep.enabled, catalogStep.reason));
      } else {
        this.wizard.step(OrderEntryStepId.CATALOG, this.wizardService.createStep(OrderEntryStepId.CATALOG, 'CATALOG.TITLE', OrderCatalogOverviewComponent, STATE_ORDERENTRY_CATALOG_OVERVIEW, catalogStep.stateParams, catalogStep.stateChildren, catalogStep.enabled, catalogStep.reason));
      }

      // don't show charges, order info, document tab when customer doesn't see prices
      this.wizard.hide(OrderEntryStepId.CHARGES, this.getWebshopContext() && this.getWebshopContext().hidePrices);
      this.wizard.hide(OrderEntryStepId.ORDERINFO, this.getWebshopContext() && this.getWebshopContext().hidePrices);
      this.wizard.hide(OrderEntryStepId.DOCUMENTS, this.getWebshopContext() && this.getWebshopContext().hidePrices);

      // don't show invoice tab when 'hideOrderEntryInvoiceTab' context is true
      // or customer doesn't see prices and has invoice fixed list selection
      this.wizard.hide(OrderEntryStepId.INVOICETO, this.getWebshopContext()?.hideOrderEntryInvoiceTab || (this.getWebshopContext()?.hidePrices && this.getWebshopContext()?.invoiceFixedListSelection));

      // don't show charges tab when customer doesn't see prices, has copy PO and can only pay with PO
      this.wizard.hide(OrderEntryStepId.PAYMENT,
        this.getWebshopContext() && this.getWebshopContext().poType !== POType.MANDATORY && this.getWebshopContext().hidePrices && this.getWebshopContext().poType !== POType.MANUAL &&
        this.orderEntryPaymentService.paymentTypes?.length === 1 && this.orderEntryPaymentService.paymentTypes[ 0 ].id === PAYMENTTYPE_PO);

      this.wizard.sync();
    }
  };

  private loadOrder():Promise<IOrderResponse | void> {
    if (this.orderId) {
      // if we first load an existing order with main or overview url, it should open in read mode
      // if we load it with child url AND if editable, it should open in edit mode
      const readStates:string[] = [
        STATE_ORDERENTRY,
        STATE_ORDERENTRY_OVERVIEW
      ];
      this.orderEntryService.orderEditable = !(!this.orderPermissions.editable || _.contains(readStates, this.stateService.current.name));

      return this.orderEntryDataService.order(this.orderId);
    } else {
      // if we first load a new order, it should open in edit mode
      this.orderEntryService.orderEditable = true;
      return Promise.resolve();
    }
  }

  private loadingDone = (loadedOrder:IOrder):void => {
    this.loadedOrder = loadedOrder;

    this.chooseState();

    this.enableDisableSteps();

    this.initialLoad = false;
  };

  private doOrderAction(order:number, statusMessage:string, actionCode:string):Promise<any> {
    const deferred:IGADeferred<any> = this.deferredService.defer();
    let msg:Noty = this.messageService.showStatusMessage('Validating...');

    const afterSave = (savedOrder:IOrderResponse):Promise<IOrderResponse> => {
      this.orderEntryService.order = savedOrder;
      this.orderId = savedOrder.id;
      this.loadedOrder.order = savedOrder;
      this.orderPermissions = savedOrder.orderPermissions;

      // clearing selected address so when navigating to the shipping or invoicing tab it will initAddressModels using server data (this.orderEntryInvoiceService.address)
      this.orderEntryInvoiceService.selectedAddress = <any>{};
      this.orderEntryShippingService.selectedAddress = <any>{};

      this.stateService.go(STATE_ORDERENTRY_OVERVIEW, { order: savedOrder.id }, {
        location: 'replace',
        custom: { afterCreate: true }
      });
      deferred.resolve(savedOrder);
      return deferred.promise;
    };

    const afterValidate = ():Promise<IOrderResponse> => {
      this.messageService.closeMessage(msg);

      // submit the order only when the confirmation page is already shown, otherwise redirect to confirmation
      if (actionCode === ACTION_CODE_GOTOSUBMIT) {
        this.goToState(STATE_ORDERENTRY_CONFIRM);
        return;
      }

      return this.checkCustomerPONumber(actionCode)
        .then(() => {
          statusMessage = statusMessage.replace(/\{order}/, <string>(order? order : ''));
          msg = this.messageService.showStatusMessage(statusMessage);
          if (order) {
            return this.orderEntryDataService.saveOrder(this.orderId, this.orderEntryService.prepareOrderForUpdate(actionCode))
              .then(afterSave);
          } else if (this.orderEntryWebshopService.selectedShop && this.orderEntryWebshopService.selectedCountry && this.orderEntryWebshopService.selectedBP) {
            return this.orderEntryDataService.createOrder(this.orderEntryWebshopService.selectedShop.id, this.orderEntryWebshopService.selectedCountry.id, this.orderEntryService.prepareOrderForSave(actionCode))
              .then(afterSave);
          }
        });
    };

    this.updateButtonStatus(actionCode, true);

    return this.tryToValidate(actionCode)
      .then(afterValidate)
      .finally(() => {
        this.messageService.closeMessage(msg);
        this.updateButtonStatus(actionCode, false);
      });
  }

  // apply or not validation based on the action code
  private tryToValidate = (actionCode:string):Promise<IValidationResults|void> => {
    if(actionCode !== ACTION_CODE_SAVEFORLATER){
      return this.wizard.validateCurrent(actionCode)
        .then(() => this.wizard.validateAll(actionCode, { orderId: this.orderId }));
    }

    // for webshop step -> validate only current tab
    if(this.wizard.activeStepId() && this.wizard.activeStepId() === OrderEntryStepId.WEBSHOP){
      return this.wizard.validateCurrent(actionCode);
    }

    return Promise.resolve();
  };

  public checkout = ():void => {
    this.doOrderAction(this.orderId, 'Submitting order {order}', this.stateService.current.name === STATE_ORDERENTRY_CONFIRM? ACTION_CODE_SUBMIT : ACTION_CODE_GOTOSUBMIT);
  };

  public saveForLater():void {
    this.doOrderAction(this.orderId, 'Saving order {order}', ACTION_CODE_SAVEFORLATER);
  }

  public sendReminder():void {
    this.orderEntryDataService.sendReminder(this.orderId)
      .then(() => {
        this.messageService.showFeedbackMessage('ORDERENTRY.REMINDER_SENT_TO_APPROVER');
        this.sendReminderDisabled = true;
      });
  }

  public cancelOrderDialog():void {
    this.updateButtonStatus(ACTION_CODE_CANCEL, true);

    const onCloseDialog = ():void => {
      cancelOrderDialog.hide();
      this.updateButtonStatus(ACTION_CODE_CANCEL, false);
    };

    const cancelOrderDialog:IDialog = this.messageService.showDialog({
      component: OrderEntryCancelDialogComponent,
      wrapperComponent: false,
      inputs: {
        title: 'ORDERENTRY.CANCEL.TITLE',
        orderId: this.orderId,
        sendMail: this.sendMail
      },
      outputs: {
        onOrderCancelled: () => {
          onCloseDialog();
          this.isCancelledSuccess();
        },
        onClose: () => {
          onCloseDialog();
        }
      },
      size: DialogSize.MD,
      callback: () => { // needed when dialog is closed with ESC key
        onCloseDialog();
      }
    });
  }

  // executed after the order is cancelled
  private isCancelledSuccess = ():void => {
    this.orderEntryService.orderStatus = 'CANCEL';
    this.orderEntryService.orderEditable = false;
    this.orderPermissions.editable = false;
    this.orderPermissions.allowCancelOrder = false;
    this.stateService.go(STATE_ORDERENTRY_OVERVIEW, { order: this.orderId }, {
      location: 'replace',
      custom: { afterCreate: true }
    });
  };

  // check for PO duplicates when submitting the order and display a warning
  private checkCustomerPONumber(actionCode:string):Promise<void> {
    const deferred:IGADeferred<any> = this.deferredService.defer();
    const customerPONumber:string = this.orderEntryInfoService.customerPONumber;
    // if there is no po number then resolve
    if (actionCode !== ACTION_CODE_SUBMIT || util.isNullOrUndefinedOrEmpty(customerPONumber)) {
      return Promise.resolve();
    }

    this.orderEntryDataService.checkCustomerPONumber(customerPONumber, this.orderEntryWebshopService.selectedShop.id, this.getWebshopContext().paymentType)
      .then((poNumberFound:IPONumberCheck) => {
        if (poNumberFound?.orderId) {
          const confirmPODialog:IDialog = this.messageService.showDialog({
            component: DefaultDialogComponent,
            wrapperComponent: false,
            inputs: {
              dialogClass: MessageType.WARNING,
              title: 'ORDERENTRY.CONFIRM.CONFIRM_SUBMIT',
              message: this.translationService.instant('ORDERENTRY.CONFIRM.PO_CHECK_DIALOG_MESSAGE', {
                customerPONumber,
                orderDetails:
                  `<ul>
                  <li>ACSL #: <a href="/ga2/#/unacc?url=%2Funacc%2FO_OrderView_Edit.jsp%3Frow0_Dereqid%3D${poNumberFound.orderId}%26ejbEvent%3Dedit" target="_blank">${poNumberFound.orderId}</a></li>
                  <li>${this.translationService.instant('GA.GENERAL.DATE')}: ${this.formattingService.formatDate(poNumberFound.orderDate)}</li>
                  <li>${this.translationService.instant('GA.GENERAL.WEBSHOP')}: ${poNumberFound.webshopName}</li>
                  <li>${this.translationService.instant('GA.GENERAL.COUNTRY')}: ${poNumberFound.countryName}</li>
                </ul>`
              }),
              buttons: [ {
                label: 'GA.GENERAL.YES',
                className: 'btn btn-danger',
                onClick: () => {
                  confirmPODialog.hide();
                  deferred.resolve();
                }
              }, {
                label: 'GA.GENERAL.NO',
                className: 'btn-success',
                onClick: () => {
                  confirmPODialog.hide();
                  this.goToState(STATE_ORDERENTRY_PAYMENT);
                  deferred.reject();
                }
              } ]
            },
            size: DialogSize.MD
          });
        } else {
          // just resolve when PO number doesn't exist
          deferred.resolve();
        }
      })
      .catch(deferred.reject);

    return deferred.promise;
  }

  private initWizard():void {
    const catalogStep:IWizardStep = this.wizardService.createStep(OrderEntryStepId.CATALOG, 'CATALOG.TITLE', OrderCatalogOverviewComponent, STATE_ORDERENTRY_CATALOG_OVERVIEW, undefined, [
      STATE_ORDERENTRY_CATALOG_OVERVIEW,
      STATE_ORDERENTRY_CATALOG_DETAIL,
      STATE_ORDERENTRY_CATALOG_GUIDE
    ], true);

    this.wizard.steps([
      this.wizardService.createStep(OrderEntryStepId.WEBSHOP, 'ORDERENTRY.WEBSHOP.TITLE', OrderEntryWebshopComponent, STATE_ORDERENTRY_WEBSHOP, undefined, undefined, true),
      catalogStep,
      this.wizardService.createStep(OrderEntryStepId.CART, 'ORDERENTRY.CART.TITLE', CartComponent, STATE_ORDERENTRY_CART, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.ORDERINFO, 'ORDERENTRY.ORDERINFO.TITLE', OrderEntryInfoComponent, STATE_ORDERENTRY_ORDER_INFO, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.PAYMENT, 'ORDERENTRY.PAYMENT.TITLE', OrderEntryPaymentComponent, STATE_ORDERENTRY_PAYMENT, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.SHIPTO, 'ORDERENTRY.SHIPPING.TITLE', OrderEntryShippingComponent, STATE_ORDERENTRY_SHIPPING, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.INVOICETO, 'ORDERENTRY.INVOICE.TITLE', OrderEntryInvoiceComponent, STATE_ORDERENTRY_INVOICE, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.CHARGES, 'ORDERENTRY.CHARGES.TITLE', OrderEntryChargesComponent, STATE_ORDERENTRY_CHARGES, undefined, undefined, true),
      this.wizardService.createStep(OrderEntryStepId.DOCUMENTS, 'ORDERENTRY.DOCS.TITLE', OrderEntryDocumentsComponent, STATE_ORDERENTRY_DOCUMENTS, undefined, undefined, true, undefined),
      this.wizardService.createStep(OrderEntryStepId.CONFIRM, 'ORDERENTRY.CONFIRM.TITLE', OrderEntryConfirmComponent, STATE_ORDERENTRY_CONFIRM, undefined, undefined, true)
    ]);

    this.wizard.sync();

    this.priceCartService.cartTab = STATE_ORDERENTRY_CART;
  }

  public edit():void {
    this.orderEntryService.orderEditable = true;
    this.chooseState();
  }

  private chooseState():void {
    const goToWebshop = ():void => {
      this.goToState(STATE_ORDERENTRY_WEBSHOP, undefined, { location: 'replace' });
    };

    const goToCatalog = ():void => {
      const catalogStartState:string = this.catalogStateService.buyingGuideId ? STATE_ORDERENTRY_CATALOG_GUIDE : STATE_ORDERENTRY_CATALOG_OVERVIEW;
      this.goToState(catalogStartState);
    };

    const goToOverview = ():void => {
      this.goToState(STATE_ORDERENTRY_OVERVIEW);
    };

    if (this.orderId && this.loadedOrder?.order) {
      this.orderPermissions = this.loadedOrder.order.orderPermissions;
      if (!this.orderPermissions.editable && this.stateService.current.name !== STATE_ORDERENTRY_OVERVIEW) {
        goToOverview();
      }
      this.orderEntryService.order = this.loadedOrder.order;
    }

    if (!this.orderEntryService.orderEditable || !this.orderPermissions.editable){
      // if read-mode, go to overview
      goToOverview();
    } else {

      if (!this.orderId) {
        // it is not a saved order

        if (this.loadedOrder.single) { // it has only one webshop & one country & BP
          if (this.stateService.current.name === STATE_ORDERENTRY_WEBSHOP) {
            //skip choosing a webshop & country
            goToCatalog();
          } else if (this.orderEntryService.requesterRequired && !this.orderEntryRequesterService.contact && this.wizard.activeStepIndex >= 4) {
            //do not go beyond the requester step
            goToWebshop();
          }
        } else {
          //make people always choose a webshop & country
          goToWebshop();
        }

      } else {
        // it is a saved order

        if (this.stateService.current.name === STATE_ORDERENTRY_OVERVIEW) {
          // coming from overview state
          goToWebshop();
        }
      }
    }
  }

  private goToState = (to:StateOrName, params?:RawParams, options?:TransitionOptions) => {
    // when there is any pending state change, enable all wizard steps and prevent enabling them until the transition has been performed
    this.hasPendingStateChange = true;
    this.wizard.allEnabled();
    this.stateService.go(to, params, options)
      .finally(() => {
        this.hasPendingStateChange = false;
        this.enableDisableSteps();
      });
  };

  public onEmailNotificationChange(sendMail:boolean):void {
    this.sendMail = sendMail;
    this.orderEntryService.noMailNotifications = !sendMail;
  }

  private overrideVAT(shipToCountryId:number, shipToStateCode:string, invoiceToCountryId:number) {
    this.orderEntryChargesDataService.loadTaxInfo(
      this.orderEntryWebshopService.selectedShop.id,
      this.orderEntryWebshopService.selectedCountry.id,
      this.orderEntryWebshopService.selectedBP.id,
      this.orderEntryInvoiceService.billingType.id,
      shipToCountryId,
      shipToStateCode,
      invoiceToCountryId
    )
      .then((taxInfo:ITaxInfo) => {
        this.orderEntryChargesService.taxPercentage = taxInfo.taxPercentage * 100;
        this.orderEntryChargesService.taxExempt(taxInfo.taxExempt);
      });
  }

  private getWebshopContext():IOrderContext {
    return this.orderEntryWebshopService.shopContext;
  }

  private updateButtonStatus(actionCode:string, executing:boolean):void {
    this.executing = executing;

    switch (actionCode) {
      case ACTION_CODE_SAVEFORLATER:
        this.buttonBusy.saveForLater = executing;
        break;
      case ACTION_CODE_SUBMIT:
      case ACTION_CODE_GOTOSUBMIT:
        this.buttonBusy.checkout = executing;
        break;
      case ACTION_CODE_CANCEL:
        this.buttonBusy.cancel = executing;
        break;
    }

    this.eventService.sendMessage(EVENT_ORDER_BUSY_STATUS_CHANGED, {
      buttonBusy: this.buttonBusy,
      executing: this.executing
    });
  }

  public uiOnParamsChanged = (newValues:any, transition:Transition):void => {
    const fromOrderId:string = transition.params('from').order;
    const toOrderId:string = newValues?.order;
    if (toOrderId) {
      if (fromOrderId !== toOrderId && !transition.options().custom.afterCreate) {
        //restart component
        this.start(toOrderId && Number(toOrderId));
      }
    }
  };

  public set orderPermissions(orderPermissions:IOrderPermissions){
    this._orderPermissions = orderPermissions;

    if (!orderPermissions.editable && this.stateService.current.name !== STATE_ORDERENTRY_OVERVIEW) {
      this.stateService.go(STATE_ORDERENTRY_OVERVIEW);
    }
  }
  public get orderPermissions():IOrderPermissions {
    return this._orderPermissions;
  }

  public get orderEditable():boolean {
    return this.orderEntryService.orderEditable;
  }

  public get title():string {
    return this.orderEntryWebshopService.title;
  }

  public get orderNumber():number {
    return this.orderEntryService.orderNumber;
  }

  public get orderStatus():string {
    return this.orderEntryService.orderStatus;
  }

  public get testMode():boolean {
    return this.orderEntryWebshopService.testMode;
  }

  public get stockOrderType():string {
    return this.orderEntryService.stockOrderTypeId;
  }

  public ngOnDestroy():void {
    this.eventHandler?.unsubscribe();
    this.stepsEventHandler?.unsubscribe();
    this.onStateSuccessHook && this.onStateSuccessHook();
    this.onStateBeforeHook && this.onStateBeforeHook();

    this.wizard.clear();
    this.orderEntryWebshopService.clear();
    this.buyingGuideModel.clear();
    this.orderEntryRequesterService.clear();
    this.bodyClassService.remove('wizard-header');
    this.orderCatalogService.clear();
    this.catalogStateService.clear();
    this.orderEntryService.clearAllOrderData();
    this.partConfiguratorDataService.clear();
    this.orderWebshopLoaderService.clear();
    this.orderEntryDataService.clear();
  }
}